.activityDivider {
  font-size: var(--tuna-typography-fontSize-xs);
  text-transform: uppercase;
}
